/* eslint-disable */
const emailRegex = /^(([^äöüß<>()\[\]\.,;:\s@\"]+(\.[^äöüß<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^äöüß<>()\[\]\.,;:\s@\"]+\.)+[^äöüß<>()\[\]\.,;:\s@\"]{2,})$/i;
const containsEmailRegex = /(([^äöüß<>()\[\]\.,;:\s@\"]+(\.[^äöüß<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^äöüß<>()\[\]\.,;:\s@\"]+\.)+[^äöüß<>()\[\]\.,;:\s@\"]{2,})/i;
const timeRegex = /^(([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9])$/i;
const phoneRegex = /^[+]?[0-9]{2,3}[-\s.]?[\d-\s.]*$/i;
const currencyRegex = /(\d+([,.])?\d{0,2})$/i;
const monthYearRegex = /^\d{4}-\d{2}$/;
const dateRegex = /^(\d){2}\.(\d){2}\.(\d){4}$/;
const hoursMinutesRegex = /^(\d){2}:(\d){2}$/;
// eslint-enable

const REGEX = Object.freeze({
    EMAIL: emailRegex,
    CONTAINS_EMAIL: containsEmailRegex,
    TIME: timeRegex,
    PHONE: phoneRegex,
    CURRENCY: currencyRegex,
    MONTH_YEAR: monthYearRegex,
    DATE: dateRegex,
    HOURS_MINUTES: hoursMinutesRegex
})

export default REGEX;